<template>
    <div>
        <v-list>
            <v-list-item
                v-for="item in items"
                :key="item.title"
                :to="{ name: 'PoiList', params: { subdepId: item.id } }"
                >
                <v-list-item-icon>
                    <v-icon>mdi-bank</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                    <v-list-item-title v-text="item.title"></v-list-item-title>
                </v-list-item-content>
                <v-list-item-avatar>
                    <v-icon v-if="item.isMain" color="yellow"> mdi-star </v-icon>
                </v-list-item-avatar>
            </v-list-item>
        </v-list>
    </div>
</template>
<script>
    import axios from "axios";
    import { EventBus } from "@/event-bus";
    import { functions } from "../functions";
    import Auth from "./Auth.vue";
    import { sort } from "fast-sort";

    export default {
        name: "SubdepList",

        props: {
            msg: String,
        },

        data: function () {
            return {
                items: [],
                rootApi: process.env.VUE_APP_ROOT_API,
                gotoMain: this.$route.params.gotoMain,
            };
        },

        created: function () {
            EventBus.$emit("eventPageLoad", {name: "Subdepartamentos"});
            this.loadList();
        },

        afterCreate: function () {},

        beforeCreate: function () {},

        methods: {
            loadList: function () {
                EventBus.$emit("eventWaitingStart");
                const url = this.rootApi + "/subdep/list";
                axios
                        .get(url, axios.getHeaders())
                        .then((response) => {
                            console.log("SubdepList: ", response.data);
                            this.createList(response.data);
                        })
                        .catch((err) => {
                            return functions.parseCatch(err, this.$appMessages.err404);
                        })
                        .finally(() => {
                            EventBus.$emit("eventWaitingEnd");
                        });
            },

            createList: function (subdeps) {

                subdeps.map((elem) => {

                    if (this.gotoMain && elem.isMain) {
                        return this.$router.push({
                            name: "PoiList",
                            params: {subdepId: elem.id},
                        });
                    }

                    this.items.push({
                        icon: elem.isMain,
                        id: elem.id,
                        title: elem.title,
                        isMain: elem.isMain,
                        avatar: "",
                    });
                });

                this.items = sort(this.items).asc([(i) => i.title]);
            },

            openPageUi: function (uiId) {
                alert(uiId);
            },
        },
    };
</script>

<style scoped>
</style>
